import React, { useEffect, useState } from "react";
import { getHeaders } from "../../ApiHeaders/apiHeadersEntitlements";
import Dropdown from "../DropDown";
import { isAmpEntitlementDomain } from "../../Admin/constants/entitlementDomains";

interface DomainData {
  domain_id: number;
  domain: string;
  description: string;
}

interface DomainDropdownProps {
  selectedDomain: string;
  onDomainChange: (domain: string) => void;
  disabled: boolean;
  className?: string;
  onFocus?: () => void;
}

const DomainDropdown: React.FC<DomainDropdownProps> = ({
  selectedDomain,
  onDomainChange,
  disabled,
  className = "",
  onFocus,
}) => {
  const [domains, setDomains] = useState<DomainData[]>([]);

  useEffect(() => {
    const fetchDomains = async () => {
      try {
        const headers = await getHeaders();

        const response = await fetch(
          `${process.env.REACT_APP_ENTITLEMENTS_API}/domain`,
          { headers }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch domains");
        }

        const data = await response.json();

        setDomains(data.response?.data || []);
      } catch (error) {
        console.error("Error fetching domains:", error);
      }
    };

    fetchDomains();
  }, []);

  const options = domains
    .filter((d) => isAmpEntitlementDomain(d.domain))
    .map((d) => ({
      value: d.domain,
      label: d.domain,
    }));

  return (
    <Dropdown
      options={options}
      selectedValue={selectedDomain || undefined}
      onValueChange={onDomainChange}
      disabled={disabled}
      className={className}
      placeholder="Select Domain"
      onFocus={onFocus}
    />
  );
};

export default DomainDropdown;
